// Mock customer/user data for the admin "Users" area.
// Structured to mirror a future /admin/users API response so the list and
// detail pages can be wired to a real endpoint with minimal changes.

const FALLBACK_AVATAR = "/images/dummyimg.png";

// Booking status -> badge styling, reused by the list and modal views.
export const BOOKING_STATUS_STYLES = {
  Active: "bg-[#E4F5E4] text-[#008000]",
  Confirmed: "bg-[#E4F5E4] text-[#008000]",
  Completed: "bg-[#F6E9F1] text-[#7A0147]",
  Canceled: "bg-[#FDECEC] text-[#FF4040]",
  "Failed Payment": "bg-[#FDECEC] text-[#FF4040]",
  Pending: "bg-[#FFF4DB] text-[#F99C07]",
};

export const USER_STATUS_STYLES = {
  Active: "bg-[#E4F5E4] text-[#008000]",
  Suspended: "bg-[#FFF4DB] text-[#F99C07]",
  Blocked: "bg-[#FDECEC] text-[#FF4040]",
};

// Booking-detail payloads keyed by service type. Each shape matches one of the
// three "Booking Details" modal variants in the design.
const rideDetails = (overrides = {}) => ({
  type: "Ride",
  driver: {
    name: "Salim Abdulaziz",
    carType: "Toyota Camry",
    carColor: "Black",
    numberPlate: "LAG-240-AB",
  },
  ride: {
    pickUp: "Peace Court Estate Lokogoma, Abuja",
    dropOff: "The Capitol Hub, Abuja",
    distance: "24km",
    duration: "42mins",
  },
  payment: {
    baseFare: 4300,
    extraCharges: 850,
    platformFee: 780,
    total: 5200,
  },
  ...overrides,
});

const assistantDetails = (overrides = {}) => ({
  type: "Pulo Assistant",
  assistant: {
    name: "Aliu Omeza",
    carType: "Toyota Camry",
    carColor: "Black",
    numberPlate: "LAG-240-AB",
  },
  trip: {
    participants: "5",
    location: "Oba Idanre",
    checkInDate: "11/12/2025",
    checkOutDate: "12/12/2025",
    itinerary: "Morning pickup, guided attraction visits, lunch stop, and evening drop-off.",
  },
  logistics: {
    securityOfficers: "2 MOPOL, 2 Army",
    convoyVehicles: "2 Hilux, 1 Prado",
  },
  payment: {
    baseTripCost: 76000,
    vehicleCost: 280000,
    securityCost: 90000,
    total: 446000,
  },
  ...overrides,
});

const accommodationDetails = (overrides = {}) => ({
  type: "Accommodation",
  accommodation: {
    propertyName: "House 40 Residence",
    address: "No.40 Nauka Estate Lokogoma, Abuja",
    checkInDate: "11/12/2025",
    checkOutDate: "12/12/2025",
    guests: "2",
  },
  payment: {
    roomCost: 190000,
    extraCharges: 5000,
    serviceFee: 12000,
    total: 446000,
  },
  ...overrides,
});

// A reusable booking-history list shown on the user detail page.
const sampleBookingHistory = [
  {
    id: "bk-1",
    name: "Aliu Omeza",
    service: "Pulo Assistant",
    location: "Abuja",
    date: "24/12/2025",
    amount: 480000,
    status: "Active",
    details: assistantDetails({ status: "Active" }),
  },
  {
    id: "bk-2",
    name: "Salim Abdulaziz",
    service: "Ride",
    location: "Kaduna",
    date: "24/12/2025",
    amount: 30000,
    status: "Completed",
    details: rideDetails({ status: "Completed" }),
  },
  {
    id: "bk-3",
    name: "House 40 Residence",
    service: "Accommodation",
    location: "Abuja",
    date: "24/12/2025",
    amount: 60300,
    status: "Completed",
    details: accommodationDetails({ status: "Completed" }),
  },
  {
    id: "bk-4",
    name: "Salim Abdulaziz",
    service: "Ride",
    location: "Abuja",
    date: "24/12/2025",
    amount: 50000,
    status: "Canceled",
    details: rideDetails({ status: "Canceled" }),
  },
  {
    id: "bk-5",
    name: "John Samuel",
    service: "Ride",
    location: "Abuja",
    date: "24/12/2025",
    amount: 50000,
    status: "Completed",
    details: rideDetails({
      status: "Completed",
      driver: {
        name: "John Samuel",
        carType: "Honda Accord",
        carColor: "Silver",
        numberPlate: "ABC-118-KJ",
      },
    }),
  },
  {
    id: "bk-6",
    name: "Joyful Peter",
    service: "Ride",
    location: "Abuja",
    date: "24/12/2025",
    amount: 50000,
    status: "Completed",
    details: rideDetails({
      status: "Completed",
      driver: {
        name: "Joyful Peter",
        carType: "Kia Rio",
        carColor: "White",
        numberPlate: "KJA-902-XY",
      },
    }),
  },
  {
    id: "bk-7",
    name: "Joyful Peter",
    service: "Ride",
    location: "Abuja",
    date: "24/12/2025",
    amount: 50000,
    status: "Completed",
    details: rideDetails({ status: "Completed" }),
  },
];

const baseUser = (overrides) => ({
  avatar: FALLBACK_AVATAR,
  email: "ni32620119@gmail.com",
  phone: "+2349059555425",
  address: "Nnamdi Azikiwe Street, Peace Couer Estate Lokogoma  Abuja",
  location: "Abuja",
  totalBookings: 8,
  totalSpending: 480000,
  lastActivity: "2 hours ago",
  status: "Active",
  bookingHistory: sampleBookingHistory,
  ...overrides,
});

export const MOCK_USERS = [
  baseUser({ id: "usr-1", name: "Ismail Nazru" }),
  baseUser({ id: "usr-2", name: "Ismail Nazru", status: "Suspended" }),
  baseUser({ id: "usr-3", name: "Ismail Nazru" }),
  baseUser({ id: "usr-4", name: "Ismail Nazru" }),
  baseUser({ id: "usr-5", name: "Ismail Nazru" }),
  baseUser({ id: "usr-6", name: "Ismail Nazru" }),
  baseUser({ id: "usr-7", name: "Ismail Nazru" }),
  baseUser({ id: "usr-8", name: "Ismail Nazru" }),
  baseUser({ id: "usr-9", name: "Ismail Nazru" }),
  baseUser({ id: "usr-10", name: "Ismail Nazru" }),
  baseUser({ id: "usr-11", name: "Ismail Nazru" }),
  baseUser({ id: "usr-12", name: "Ismail Nazru" }),
];

export const getUserById = (id) =>
  MOCK_USERS.find((user) => String(user.id) === String(id)) || null;

export const formatNaira = (value) => {
  const amount = Number(value);
  if (!Number.isFinite(amount)) return "—";
  return `N${amount.toLocaleString()}`;
};

export const formatNairaDecimal = (value) => {
  const amount = Number(value);
  if (!Number.isFinite(amount)) return "—";
  return `N${amount.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
};

export { FALLBACK_AVATAR };
